import React, { useState, useEffect } from "react";
import { Transition } from "react-transition-group"; // ES6
import { deletePhase, changePhase } from "../reducers/slices/phases.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faTrash } from "@fortawesome/pro-solid-svg-icons";

export default function PhaseWrapper(props) {
  const [hovering, setHovering] = useState(false);
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);
  const transitionStyles = props.horizontal
    ? {
        entering: {},
        entered: { transition: "none" },
        exiting: {
          height: 0,
          width: 0,
        },
        exited: {
          width: 0,
          height: 0,
          transition: "none",
        },
      }
    : {
        entering: {},
        entered: { transition: "none" },
        exiting: {
          height: 0,
        },
        exited: {
          height: 0,
          transition: "none",
        },
      };

  const handlebarTransitionStyles = {
    entering: {},
    entered: { transition: "none" },
    exiting: {
      opacity: 0,
    },
    exited: {
      opacity: 0,
      transition: "none",
    },
  };

  const spacerTransitionStyles = {
    entering: {},
    entered: { transition: "none" },
    exiting: {
      height: 0,
    },
    exited: {
      height: 0,
      transition: "none",
    },
  };

  if (!props.hoverConfig) {
    return props.children;
  }  else {
    return (
      <Transition in={props.isMount || show} timeout={300}>
        {(state) => {

          return (
            <>
              <div
                key={props.id}
                onMouseEnter={() => {
                  setHovering(true);
                }}
                onMouseLeave={() => {
                  setHovering(false);
                }}
                style={{}}
              >
                <div
                  onClick={() => {
                    setHovering(true);
                    props.dispatch(changePhase(props.id));
                  }}
                  style={{
                    position: "relative",
                    height: props.height,
                    width: props.width,
                    overflow: "hidden",
                    cursor: "pointer",
                    transition:
                      props.hoverConfig.type !== "display"
                        ? (props.horizontal ? "all" : "height") + " 0.3s"
                        : "",
                    outlineOffset: -4,
                    outlineWidth: 4,
                    outlineStyle: "solid",
                    outlineColor: props.hoverConfig.active
                      ? "rgb(10,132,255)"
                      : hovering
                      ? "rgba(32, 33, 36, 0.8)"
                      : "transparent",
                    ...props.style,
                    ...transitionStyles[state],
                  }}
                >
                  {props.children}
                  <div
                    {...props.dragHandleProps}
                    className={"dragHandle"}
                    style={{
                      padding: "5px 10px",
                      cursor: "grab",
                      display: hovering ? "flex" : "none",
                      position: "absolute",
                      top: 3,
                      right: 3,
                      left: 3,
                      flexDirection: "row",
                      justifyContent: "center",
                      backgroundColor: "rgba(45, 55, 72, 0.8)",
                      color: "white",
                      opacity:1,
                      ...handlebarTransitionStyles[state],
                    }}
                  >
                    {props.hoverConfig.type !== "display" && (
                      <div
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          style={{ fontSize: 16, paddingRight: 10 }}
                          icon={faGripVertical}
                        />
                      </div>
                    )}
                    <div
                      style={{ color: "white", fontWeight: 600, fontSize: 14 }}
                    >
                      {props.title}
                    </div>
                    {props.hoverConfig.type !== "display" && (
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          justifyContent: "flex-end",
                        }}
                      >
                        <div
                          onClick={(x) => {
                            setShow(false);
                            setTimeout(
                              () =>
                                props.dispatch(deletePhase({ id: props.id })),
                              300
                            );
                            x.stopPropagation();
                          }}
                          style={{
                            marginTop: -10,
                            textAlign: "center",
                            marginRight: -10,
                            width: 35,
                            height: 30,
                            float: "right",
                          }}
                        >
                          <FontAwesomeIcon
                            style={{ marginTop: 7, padding: 5, fontSize: 16 }}
                            icon={faTrash}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {!props.horizontal && (
                <div
                  style={{
                    height: props.horizontal ? 0 : 15,
                    transition: "height 0.3s",
                    ...spacerTransitionStyles[state],
                  }}
                ></div>
              )}
            </>
          );
        }}
      </Transition>
    );
  }
}
